import * as Context from "effect/Context";
import * as Effect from "effect/Effect";
export class Cli extends Context.Service()("CLI") {
}
//# sourceMappingURL=Cli.js.map